import {
  availabilitySearch, getLocations,
} from '../services/api';

import { searchActions } from '../reducers/search';

export const {
  setSearchLocations,
  setSelectedLocation,
  onSetAvailabilityProducts,
  onSetLocationLoading,
  onSetSearchFinish,
  onSetSearchLoading,
  onSetSearchMeta,
  onSetSearchStart,
} = searchActions;

export const fetchLocations = (params) => (dispatch) => new Promise((resolve, reject) => {
  dispatch(searchActions.onSetLocationLoading(true));
  getLocations(params).then((data) => {
    dispatch(searchActions.onSetLocationLoading(false));
    dispatch(searchActions.setSearchLocations(data.locations));
    resolve(data);
  }).catch((error) => {
    dispatch(searchActions.onSetLocationLoading(false));
    reject(error);
  });
});

export const fetchAvailabilityProducts = (params, callback) => (dispatch) => new Promise((resolve, reject) => {
  dispatch(onSetSearchLoading(true));
  availabilitySearch(params).then((data) => {
    dispatch(onSetAvailabilityProducts(data.products));
    dispatch(onSetSearchMeta(data.meta));
    dispatch(onSetSearchLoading(false));
    if (callback) callback(data);
    resolve(data);
  }).catch((error) => {
    dispatch(onSetSearchLoading(false));
    reject(error);
  });
});
